import { parseISO } from "date-fns";
import formatDateAndTime from "./formatDateAndTime";

const handleNullTimeEntries = (
  inputDate: string,
  inputTime: string | undefined
) => {
  if (inputTime === null) {
    return new Date(`${inputDate}`);
  }
  const parsedDate = parseISO(inputDate);
  const { formattedDate, formattedTime } = formatDateAndTime(parsedDate);

  return new Date(`${formattedDate}T${inputTime}`);
};

export default handleNullTimeEntries;
